import React from 'react';
import { AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react';
import { SHADCN, R, TYPO, S, FS } from '../theme';

// ── <Alert> — Shadcn dark ───────────────────────────────────────────────────
// Bandeau inline, fond pastel @8%, filet @30%, texte de la couleur sémantique.

const TONES = {
  info:    { bg: 'oklch(0.685 0.169 237.323 / 0.1)', border: 'oklch(0.685 0.169 237.323 / 0.3)', color: SHADCN.info,    Icon: Info },
  success: { bg: 'oklch(0.871 0.15 154.449 / 0.08)', border: 'oklch(0.871 0.15 154.449 / 0.3)', color: SHADCN.success, Icon: CheckCircle },
  warning: { bg: 'oklch(0.852 0.199 91.936 / 0.08)', border: 'oklch(0.852 0.199 91.936 / 0.3)', color: SHADCN.warning, Icon: AlertTriangle },
  error:   { bg: 'oklch(0.577 0.245 27.325 / 0.12)', border: 'oklch(0.577 0.245 27.325 / 0.4)', color: SHADCN.error,   Icon: XCircle },
};

export default function Alert({ variant = 'warning', icon = true, children, style }) {
  const t = TONES[variant] || TONES.warning;

  return (
    <div style={{
      background: t.bg,
      border: `1px solid ${t.border}`,
      borderRadius: R.md,
      padding: `${S[3]}px ${S[4]}px`,
      display: 'flex',
      alignItems: 'flex-start',
      gap: S[3],
      ...style,
    }}>
      {icon && <t.Icon size={18} color={t.color} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} />}
      <div style={{ ...TYPO.body, color: t.color, minWidth: 0, flex: 1 }}>
        {children}
      </div>
    </div>
  );
}
